import {apiEndpoints} from './api-endpoints';

export const environment = Object.assign({
    production: false,
    hmr: false,
}, apiEndpoints);
